export function readCookie(
  name: string,
  cookieHeader: string = document.cookie
): string | undefined {
  for (const entry of cookieHeader.split(';')) {
    const separator = entry.indexOf('=');
    if (separator < 0 || entry.slice(0, separator).trim() !== name) continue;

    const value = entry.slice(separator + 1).trim();
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }
  return undefined;
}

export function countryCookie(countryCode: string, expires: Date): string {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  return `locationData=${encodeURIComponent(countryCode)}; expires=${expires.toUTCString()}; Path=/; SameSite=Lax${secure}`;
}
